import {createReducer} from "typesafe-actions";
import update from "immutability-helper";
import {DataSignatureState} from "../types/dataSignatures";
import {gotDataJson, gotDataSignatures} from "../actions/signatures";

const initialState: DataSignatureState = {
    total: 0,
};

export const dataSignaturesReducer = createReducer(initialState)
    .handleAction(gotDataSignatures, (state, action) => update(state, {
        signatures: {$set: action.payload.items},
        total: {$set: action.payload.total},
    }))
    .handleAction(gotDataJson, (state, action) => update(state, {
        json: {$set: action.payload},
    }))
;
